export default function Tools(_ref) {
  let {
    items = []
  } = _ref;
  if (!items.length) return null;
  return m('section.dc-section.dc-section--tight', m('div.dc-container', [m('header.dc-section-head', [m('div', [m('h2', 'Инструменты разработчика'), m('p', 'Проверенные сервисы и утилиты для реальных задач')]), m('a.dc-link', {
    href: '/tools'
  }, 'Весь каталог →')]), m('div.dc-tools-preview', items.map(item => m('a.dc-tool-preview.dc-card', {
    href: item.websiteUrl,
    target: '_blank',
    rel: 'noopener noreferrer nofollow'
  }, [m('span.dc-tool-preview__icon', item.name.slice(0, 1).toUpperCase()), m('span', [m('b', item.name), m('small', item.summary)]), m('span.dc-tool-preview__arrow', '↗')])))]));
}
flarum.reg.add('devconnect-portal', 'forum/components/Tools', Tools);